import React, { useState, useEffect } from "react";
import { getAllBlog } from "../../api/api";
import Header from "../../components/header";
import image from "../../assets/image/blog.webp";
import { Row, Col, Card, Pagination } from "react-bootstrap";
import location from "../../assets/location.svg";
import dayjs from "dayjs";
import "./blog.css";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { handleError } from "../../helpers/handleError";
import SpinLoading from "../../components/spinLoading/SpinLoading";
const Blog = () => {
  const [blog, setBlog] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 0,
  });
  const navigate = useNavigate();
  const nav = [
    {
      title: "Inicio",
      path: "/event",
    },
    {
      title: "Blog",
      path: "/blog",
    },
  ];
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const isTablet = useMediaQuery({ maxWidth: 900 });
  const isLarge = useMediaQuery({ maxWidth: 1200 });
  const isDesktop = useMediaQuery({ maxWidth: 1400 });
  const maxVisiblePages = isMobile ? 1 : isTablet ? 3 : isLarge ? 5 : isDesktop ? 7 : 11;

  const renderPageNumbers = () => {
    let startPage = Math.max(1, pagination.currentPage - Math.floor(maxVisiblePages / 2));
    const endPage = Math.min(pagination.totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    const pageNumbers = [];
    if (startPage > 1) {
      pageNumbers.push(
        <Pagination.Item key={1} onClick={() => fetchBlog(1)}>
          1
        </Pagination.Item>
      );
      if (startPage > 2) {
        pageNumbers.push(<Pagination.Ellipsis key="startEllipsis" />);
      }
    }
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item key={i} active={i === pagination.currentPage} onClick={() => fetchBlog(i)}>
          {i}
        </Pagination.Item>
      );
    }
    if (endPage < pagination.totalPages) {
      if (endPage < pagination.totalPages - 1) {
        pageNumbers.push(<Pagination.Ellipsis key="endEllipsis" />);
      }
      pageNumbers.push(
        <Pagination.Item key={pagination.totalPages} onClick={() => fetchBlog(pagination.totalPages)}>
          {pagination.totalPages}
        </Pagination.Item>
      );
    }

    return pageNumbers;
  };

  const fetchBlog = async (page = 1) => {
    try {
      setLoading(true);
      const response = await getAllBlog(page);
      if (response.status === 200) {
        setBlog(response.data.info.blog);
        setPagination({
          currentPage: response.data.info.pagination.currentPage,
          totalPages: response.data.info.pagination.totalPages,
        });
      }
      setLoading(false);
    } catch (error) {
      handleError(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchBlog();
  }, []);
  if (loading) return <SpinLoading />;
  return (
    <>
      <Header imageSrc={image} title="Blog" navigation={nav} />
      <div className="pading150 bloglistcontainer">
        <Row>
          {blog.map((item, index) => (
            <Col xs={12} sm={6} md={6} lg={4} xl={4} xxl={4} className="bloglist">
              <Card className="bloglistcard">
                <div className="bloglistcardimage">
                  <Card.Img className="bloglistimage" variant="top" src={item.image} />
                  <div className="bloglistcardimageoverlay">
                    <img src={location} alt="location" /> {item.fullName}
                  </div>
                </div>
                <Card.Body>
                  <Card.Text className="bloglistcarddate">{dayjs(item.createdAt).format("D [de] MMMM [de] YYYY")}</Card.Text>
                  <Card.Title className="bloglistcardtitle">{item.title}</Card.Title>
                  <Card.Text className="bloglistcarddescription">{item.description}</Card.Text>
                  <button className="bloglistbutton" onClick={() => navigate(`/blog/${item._id}`)}>
                    Leer más
                    <span className="bloglistarrow">
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M11.7803 5.46967C12.0732 5.76256 12.0732 6.23744 11.7803 6.53033L7.28033 11.0303C6.98744 11.3232 6.51256 11.3232 6.21967 11.0303C5.92678 10.7374 5.92678 10.2626 6.21967 9.96967L9.43934 6.75L0.75 6.75C0.335787 6.75 0 6.41421 0 6C0 5.58579 0.335787 5.25 0.75 5.25L9.43934 5.25L6.21967 2.03033C5.92678 1.73744 5.92678 1.26256 6.21967 0.96967C6.51256 0.676777 6.98744 0.676777 7.28033 0.96967L11.7803 5.46967Z"
                          fill="#0D263C"
                        />
                      </svg>
                    </span>
                  </button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
      {pagination.totalPages > 1 && (
        <div className="pagination-bullets-event pading150">
          <Pagination className="pagination-event">
            {pagination.currentPage > 1 && (
              <Pagination.Prev
                onClick={() => {
                  fetchBlog(pagination.currentPage - 1);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              />
            )}

            {renderPageNumbers()}
            {pagination.currentPage !== pagination.totalPages && (
              <Pagination.Next
                onClick={() => {
                  fetchBlog(pagination.currentPage + 1);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              />
            )}
          </Pagination>
        </div>
      )}
    </>
  );
};

export default Blog;
